import { render, staticRenderFns } from "./MaintenanceForm.vue?vue&type=template&id=6368c698"
import script from "./MaintenanceForm.vue?vue&type=script&lang=js"
export * from "./MaintenanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports